
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/streamers/all",
      function () {
        return require("private-next-pages/streamers/all.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/streamers/all"])
      });
    }
  